import { useEffect, useRef, useState } from "react";

// Sizes a hero section to the natural aspect ratio of its background image so the
// full image is visible (no crop). A minimum height keeps overlaid text readable
// — especially on mobile, where wide images would otherwise become too short.
export const useAdaptiveHero = (src, { mobileMinVh = 72, desktopMinVh = 58 } = {}) => {
  const ref = useRef(null);
  const [ratio, setRatio] = useState(null);
  const [height, setHeight] = useState(null);

  useEffect(() => {
    setRatio(null);
    if (!src) return;
    const im = new Image();
    im.onload = () => im.naturalHeight && setRatio(im.naturalWidth / im.naturalHeight);
    im.src = src;
  }, [src]);

  useEffect(() => {
    if (!ratio) {
      setHeight(null);
      return;
    }
    const measure = () => {
      const w = ref.current?.offsetWidth || window.innerWidth;
      const isMobile = window.innerWidth < 640;
      const minH = Math.round((window.innerHeight * (isMobile ? mobileMinVh : desktopMinVh)) / 100);
      setHeight(Math.max(Math.round(w / ratio), minH));
    };
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, [ratio, mobileMinVh, desktopMinVh]);

  return { ref, height };
};
